import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './common/locales/en.json';
import vi from './common/locales/vi.json';
import es from './common/locales/es.json';
import de from './common/locales/de.json';
import hi from './common/locales/hi.json';
import fr from './common/locales/fr.json';
import it from './common/locales/it.json';
import pl from './common/locales/pl.json';
import pt from './common/locales/pt.json';
import tr from './common/locales/tr.json';
import ru from './common/locales/ru.json';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,
    ns: 'common',
    defaultNS: 'common',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { common: en },
      vi: { common: vi },
      es: { common: es },
      de: { common: de },
      hi: { common: hi },
      fr: { common: fr },
      it: { common: it },
      pl: { common: pl },
      pt: { common: pt },
      tr: { common: tr },
      ru: { common: ru },
    },
  });

export default i18n;
